import { setShowCaveatModal } from '../../../State/showCaveatModal';

export default () => async (dispatch) => {

  dispatch(setShowCaveatModal(true));
  
}